import type { CsvEntity } from '@royaltyflow/validation';

export function CsvTemplateLink({ entity }: { entity: CsvEntity }) {
  return (
    <p className="rfp-card__caption">
      <a href={`${process.env.PUBLIC_URL}/templates/${entity}-template.csv`} download>
        Download {entity} CSV template
      </a>{' '}
      — keep the header row and add your data below it.
      {entity === 'sales' &&
        ' Use the season code shown above (for example S1) in season_id and YYYY-MM-DD dates.'}
    </p>
  );
}
